// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getLocator } from '@tcp/core/src/utils';
import { BadgeContainer } from '@tcp/core/src/components/features/browse/ProductListing/atoms/CustomBadge/styles/CustomBadge.style';

const CustomBadge = (props) => {
  const { type, className, text, customFontWeight, customFontSize } = props;
  return (
    <BadgeContainer className={className} type={type}>
      <BodyCopy
        dataLocator={getLocator('global_productbadge_txt')}
        fontFamily="secondary"
        fontWeight={customFontWeight || 'bold'}
        fontSize={customFontSize}
        className="top-badge-label"
        tabIndex="0"
        aria-label={`${text} Badge`}
      >
        {text}
      </BodyCopy>
    </BadgeContainer>
  );
};

CustomBadge.defaultProps = {
  type: '',
  className: '',
  text: '',
  customFontWeight: '',
  customFontSize: ['fs8', 'fs8', 'fs10'],
};

CustomBadge.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  customFontWeight: PropTypes.string,
  customFontSize: PropTypes.arrayOf(PropTypes.string),
};

export default CustomBadge;
